import { Geolocation } from "@capacitor/geolocation";

export default async function getGpsLocationApp(callback) {
  try {
    const permissionStatus = await Geolocation.checkPermissions();

    if (permissionStatus.location !== "granted") {
      const requestStatus = await Geolocation.requestPermissions();
      if (requestStatus.location !== "granted") {
        window.popupAlert("Enable location from the settings");
      }
    }

    let options = {
      maximumAge: 3000,
      timeout: 10000,
      enableHighAccuracy: false,
    };

    let location = await Geolocation.getCurrentPosition(options);
    callback(location.coords);
  } catch (e) {
    window.popupAlert(e.message);
  }
}
